export default "__VITE_ASSET__aRC482nk__"